import { Avatar, Flex, Heading, Tag, TagText, Text } from "@govlaunch/web";
import Box, { BoxProps } from "@govlaunch/web/src/box/Box";
import React, { ReactElement, ReactNode } from "react";
import { IProductFieldsFragment } from "../fragments/__generated__/ProductFieldsFragment.generated";

interface IProductHeaderProps extends BoxProps {
  product: IProductFieldsFragment;
  renderTagLinkWrap?: (tag: NonNullable<IProductFieldsFragment["tags"]>[0], children: ReactNode) => ReactNode;
  translationButton?: () => ReactElement | null;
  isMobile: boolean;
}

export default function ProductHeader({
  product,
  renderTagLinkWrap,
  translationButton,
  isMobile,
  ...props
}: IProductHeaderProps) {
  const tags = (
    <Box mt={3}>
      {product.tags.map((tag) => {
        const children = (
          <Tag mr={2} mb={2} key={tag._id} color="black" title={tag.name}>
            <TagText>{tag.name}</TagText>
          </Tag>
        );

        return renderTagLinkWrap ? renderTagLinkWrap(tag, children) : children;
      })}
    </Box>
  );

  return (
    <Box {...props}>
      <Flex alignItems={["flex-start", "flex-start", "flex-start", "center"]}>
        <Avatar
          src={product.logo}
          name={product.name}
          size="xl"
          variant={product.isDisruptor ? "disruptor" : undefined}
        />

        <Box ml={6} width="100%">
          <Flex justifyContent="space-between">
            <Heading as="h1" size="xl" color="blue.600">
              {product.name}
            </Heading>
            <div
              css={{
                paddingTop: !isMobile ? "8px" : "0px",
              }}
            >
              {translationButton ? translationButton() : null}
            </div>
          </Flex>
          <Text mt={2} fontSize="md" title={product.description || undefined}>
            {product.description}
          </Text>

          <Box display={["none", "none", "none", "block"]}>{tags}</Box>
        </Box>
      </Flex>

      <Box display={["block", "block", "block", "none"]}>{tags}</Box>
    </Box>
  );
}
